class CreatePackageReq {
  constructor() {
    this.metaSession = {
      id: undefined,
      patientNumber : undefined,
      timeStamp: undefined,
      sessionId: undefined,
      patientId: undefined,
      therapistId: undefined,
      accountingTherapistHourId: undefined,
      isPaidFor: undefined,
      originalPrice: undefined,
      finalPrice: undefined,
      discount: undefined,
      appointmentId: undefined,
      accountingEntryId: undefined,
      phoneNumber: undefined,

    };
    this.id = undefined;
    this.patientNumber = undefined;
    this.patientId = undefined;
    this.startdatefrom = undefined;
    this.startdateto = undefined;
    this.packageName = undefined;
    this.packageGroupId = undefined;
    this.quantity = undefined;
    this.sessionId = undefined;
    this.isPostPaid = undefined;

    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined,
    };
  }
}
export default CreatePackageReq;
